export const getCurrentUser = async (term) => {   
    try {     
        var response = await fetch(`/api/auth/user`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return { responseStatus: 401 };
    }
}

export const signOut = async () => {    
    try {     
        var response = await fetch(`/api/auth/logout`, {
            method: "POST",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return { responseStatus: 401 };
    }
}

export const search = async (term) => {    
    try {     
        var response = await fetch(`/api/search/search?term=${term}`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return { responseStatus: 401 };
    }
}

export const getNavigation = async (term) => {   
    try {     
        var response = await fetch(`/api/nav/navigation`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return { responseStatus: 401 };
    }
}
    
export const getClub = async (id) => {    
    try {     
        var response = await fetch(`/api/club/get-club?clubId=${id}`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return { responseStatus: 401 };
    }
}
    
export const getPlayer = async (id) => {    
    try {     
        var response = await fetch(`/api/player/get-player?playerId=${id}`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return { responseStatus: 401 };
    }
}

export const getAllTags = async () => {
    try {     
        var response = await fetch(`/api/taxonomy/get-all`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return [{ responseStatus: 401 }];
    }
}

export const getClubListForDropdown = async () => {
    try {     
        var response = await fetch(`/api/taxonomy/get-clubs`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return [{ responseStatus: 401 }];
    }
}

export const getPlayerListForDropdown = async () => {
    try {     
        var response = await fetch(`/api/taxonomy/get-players`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return [{ responseStatus: 401 }];
    }
}

export const getRepsListForDropdown = async ({ page = 1, pageSize = 20, searchTerm = "" } = {}) => {
    try {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (pageSize) params.append('pageSize', pageSize);
        if (searchTerm) params.append('searchTerm', searchTerm);
        
        var response = await fetch(`/api/taxonomy/get-representatives?${params.toString()}`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch(error) {
        return [{ responseStatus: 401 }];
    }
}

export const getNotificationCount = async () => {
    try {
        var response = await fetch(`/api/notification/get-count`, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch (error) {
        return 0;
    }
};

export const getNotifications = async (pageNumber = 1, pageSize = 8, dateFrom = null, dateTo = null, sortField = "CreatedWhen", sortOrder = -1) => {
    try {
        let url = `/api/notification/get-notifications?pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}`;
        if (dateFrom) url += `&dateFrom=${dateFrom}`;
        if (dateTo) url += `&dateTo=${dateTo}`;
        var response = await fetch(url, {
            method: "GET",
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch (error) {
        return [{ responseStatus: 401 }];
    }
}
export const markNotificationAsRead = async (notificationId) => {
    try {
        var response = await fetch(`/api/notification/mark-notification-read?notificationId=${notificationId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include", // Important to include cookies
        });
        var json = await response.json();
        return json;
    } catch (error) {
        return { responseStatus: 401 };
    }
};

export const getMatchReports = async (pageNumber = 1, pageSize = 8) => {
    try {
        const response = await fetch(`/api/matchreport/list-match-reports?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], responseStatus: 401 };
    }
};

export const getMatchReportsForPlayer = async (playerId, pageNumber = 1, pageSize = 8) => {
    try {
        const response = await fetch(`/api/matchreport/list-match-reports-for-player?pageNumber=${pageNumber}&pageSize=${pageSize}&playerId=${playerId}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], responseStatus: 401 };
    }
};

export const getMatchReportById = async (id) => {
    try {
        const response = await fetch(`/api/matchreport/get-match-report?matchReportId=${id}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { responseStatus: 401 };
    }
};

export const getClubRequirements = async (request = {}) => {
    try {
        const response = await fetch(`/api/clubrequirement/list-club-requirements`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber: request.pageNumber || 1, pageSize: request.pageSize || 20, responseStatus: 401 };
    }
};

export const getClubRequirementsFilters = async (request = {}) => {
    try {
        const response = await fetch(`/api/clubrequirement/list-club-requirements-filters`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber: request.pageNumber || 1, pageSize: request.pageSize || 20, responseStatus: 401 };
    }
};

export const getClubRequirementById = async (id) => {
    try {
        const response = await fetch(`/api/clubrequirement/get-club-requirement?clubRequirementId=${id}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { responseStatus: 401 };
    }
};

export const getMyPlayers = async (request = {}) => {
    try {
        const response = await fetch(`/api/dashboard/get-my-players`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber: request.pageNumber || 1, pageSize: request.pageSize || 8, responseStatus: 401 };
    }
}
export const getMyPlayersFilters = async (request = {}) => {
    try {
        const response = await fetch(`/api/dashboard/get-my-players-filters`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber: request.pageNumber || 1, pageSize: request.pageSize || 8, responseStatus: 401 };
    }
}

// Get current transfer window setting
export const getCurrentTransferWindow = async () => {
    try {
        const response = await fetch(`/api/settings/current-transfer-window`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { currentTransferWindow: "", responseStatus: 401 };
    }
};

// Set current transfer window setting
export const setCurrentTransferWindow = async (transferWindow) => {
    try {
        const response = await fetch(`/api/settings/set-current-transfer-window`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                currentTransferWindow: transferWindow
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

// Add candidate to requirement
export const addCandidateToRequirement = async (requirementId, playerId, skills, budget, status) => {
    try {
        const response = await fetch(`/api/clubrequirement/add-candidate`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                requirementId,
                playerId,
                skills,
                budget,
                status
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const getPlayerComments = async (playerId, pageNumber = 1, pageSize = 10) => {
    try {
        const response = await fetch(`/api/player/get-player-comments?playerId=${playerId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber, pageSize, responseStatus: 401 };
    }
};

export const addPlayerComment = async (playerId, commentText) => {
    try {
        const response = await fetch(`/api/player/add-player-comment`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({ playerId, commentText })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const deletePlayerComment = async (commentId, playerId) => {
    try {
        const response = await fetch(`/api/player/delete-player-comment?commentId=${commentId}&playerId=${playerId}`, {
            method: "POST",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};
export const addMatchReport = async ({
    matchDate,
    homeClubId,
    homeScore,
    awayClubId,
    awayScore,
    matchLocation,
    matchReportContent,
    playerIds,
    reportSubmittedById,
    ageGroup,
    images,
    videos,
    teamSheet
}) => {
    try {
        const formData = new FormData();
        formData.append('matchDate', matchDate);
        formData.append('homeClubId', homeClubId);
        formData.append('homeScore', homeScore);
        formData.append('awayClubId', awayClubId);
        formData.append('awayScore', awayScore);
        formData.append('matchLocation', matchLocation);
        formData.append('matchReportContent', matchReportContent);
        formData.append('reportSubmittedById', reportSubmittedById);
        
        // Append ageGroup if provided
        if (ageGroup) {
            formData.append('ageGroup', ageGroup);
        }

        // Append playerIds as array
        if (Array.isArray(playerIds)) {
            playerIds.forEach(id => formData.append('playerIds', id));
        }

        // Append images
        if (Array.isArray(images)) {
            images.forEach(file => {
                if (file) formData.append('images', file);
            });
        }

        // Append videos
        if (Array.isArray(videos)) {
            videos.forEach(file => {
                if (file) formData.append('videos', file);
            });
        }

        // Append teamSheet (single file)
        if (teamSheet) {
            formData.append('teamSheet', teamSheet);
        }

        const response = await fetch(`/api/matchreport/add-match-report`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const getMatchReportForEdit = async (id) => {
    try {
        const response = await fetch(`/api/matchreport/get-match-report-for-edit?matchReportId=${id}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        // Fetch media files as well
        const media = await getMatchReportMedia(id);
        return { ...json, media };
    } catch (error) {
        return { responseStatus: 401 };
    }
};

export const updateMatchReport = async ({
    id,
    matchDate,
    homeClubId,
    homeScore,
    awayClubId,
    awayScore,
    matchLocation,
    matchReportContent,
    playerIds,
    reportSubmittedById,
    ageGroup,
    images,
    videos,
    teamSheet,
    removedMedia // [{fileId, mediaType}]
}) => {
    try {
        // Remove media files if any
        if (Array.isArray(removedMedia) && removedMedia.length > 0) {
            for (const rm of removedMedia) {
                await removeMatchReportMedia({
                    matchReportId: id,
                    fileId: rm.fileId,
                    mediaType: rm.mediaType
                });
            }
        }

        const formData = new FormData();
        formData.append('id', id);
        formData.append('matchDate', matchDate);
        formData.append('homeClubId', homeClubId);
        formData.append('homeScore', homeScore);
        formData.append('awayClubId', awayClubId);
        formData.append('awayScore', awayScore);
        formData.append('matchLocation', matchLocation);
        formData.append('matchReportContent', matchReportContent);
        formData.append('reportSubmittedById', reportSubmittedById);
        
        // Append ageGroup if provided
        if (ageGroup) {
            formData.append('ageGroup', ageGroup);
        }

        if (Array.isArray(playerIds)) {
            playerIds.forEach(pid => formData.append('playerIds', pid));
        }
        if (Array.isArray(images)) {
            images.forEach(file => {
                if (file) formData.append('images', file);
            });
        }
        if (Array.isArray(videos)) {
            videos.forEach(file => {
                if (file) formData.append('videos', file);
            });
        }
        if (teamSheet) {
            formData.append('teamSheet', teamSheet);
        }

        const response = await fetch(`/api/matchreport/update-match-report`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const getMatchReportMedia = async (matchReportId) => {
    try {
        const response = await fetch(`/api/matchreport/get-match-report-media?matchReportId=${matchReportId}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { Images: [], Videos: [], TeamSheet: [] };
    }
};

export const removeMatchReportMedia = async ({ matchReportId, fileId, mediaType }) => {
    try {
        const response = await fetch(`/api/matchreport/remove-match-report-media?matchReportId=${matchReportId}&fileId=${fileId}&mediaType=${mediaType}`, {
            method: "POST",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false };
    }
};

export const removeMatchReportPlayer = async (matchReportId, playerId) => {
    try {
        const response = await fetch(`/api/matchreport/remove-match-report-player?matchReportId=${matchReportId}&playerId=${playerId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            } 
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false };
    }
};

export const deleteMatchReport = async (id) => {
    try {
        const response = await fetch(`/api/matchreport/delete-match-report?matchReportId=${id}`, {
            method: "POST",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const addClubRequirement = async ({
    league,
    club,
    squad,
    position,
    contract,
    skills,
    budget,
    comments,
    transferWindow,
    status,
    createdById
}) => {
    try {
        const response = await fetch(`/api/clubrequirement/add-club-requirement`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                league,
                club,
                squad,
                position,
                contract,
                skills,
                budget,
                comments,
                transferWindow,
                status,
                createdById
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updateClubRequirement = async ({
    id,
    league,
    club,
    squad,
    position,
    contract,
    skills,
    budget,
    comments,
    transferWindow,
    status,
    createdById
}) => {
    try {
        const response = await fetch(`/api/clubrequirement/update-club-requirement`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                id,
                league,
                club,
                squad,
                position,
                contract,
                skills,
                budget,
                comments,
                transferWindow,
                status,
                createdById
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const deletePlayer = async (playerId) => {
    try {
        const response = await fetch(`/api/player/delete-player?playerId=${playerId}`, {
            method: "POST",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const deleteClub = async (clubId) => {
    try {
        const response = await fetch(`/api/club/delete-club?clubId=${clubId}`, {
            method: "POST",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const addClub = async ({
    clubDisplayName,
    league,
    addressLine1,
    addressLine2,
    townCity,
    region,
    postcode,
    emailAddress,
    phoneNumber,
    faxNumber,
    trainingGroundName,
    trainingGroundAddressLine1,
    trainingGroundAddressLine2,
    trainingGroundTownCity,
    trainingGroundRegion,
    trainingGroundPostcode,
    trainingGroundEmail,
    trainingGroundTelephone,
    trainingGroundFax,
    academyName,
    academyAddressLine1,
    academyAddressLine2,
    academyTownCity,
    academyRegion,
    academyPostcode,
    academyContactName,
    academyPhoneNumber,
    academyEmail,
    academyFax,
    representativeIds,
    avatar
}) => {
    try {
        const formData = new FormData();
        formData.append('clubDisplayName', clubDisplayName);
        if (league) formData.append('league', league);
        formData.append('addressLine1', addressLine1);
        formData.append('addressLine2', addressLine2);
        formData.append('townCity', townCity);
        if (region && region !== 'undefined') {
            formData.append('region', region);
        }
        formData.append('postcode', postcode);
        formData.append('emailAddress', emailAddress);
        formData.append('phoneNumber', phoneNumber);
        formData.append('faxNumber', faxNumber);
        formData.append('trainingGroundName', trainingGroundName);
        formData.append('trainingGroundAddressLine1', trainingGroundAddressLine1);
        formData.append('trainingGroundAddressLine2', trainingGroundAddressLine2);
        formData.append('trainingGroundTownCity', trainingGroundTownCity);
        if (trainingGroundRegion && trainingGroundRegion !== 'undefined') {
            formData.append('trainingGroundRegion', trainingGroundRegion);
        }
        formData.append('trainingGroundPostcode', trainingGroundPostcode);
        formData.append('trainingGroundEmail', trainingGroundEmail);
        formData.append('trainingGroundTelephone', trainingGroundTelephone);
        formData.append('trainingGroundFax', trainingGroundFax);
        formData.append('academyName', academyName);
        formData.append('academyAddressLine1', academyAddressLine1);
        formData.append('academyAddressLine2', academyAddressLine2);
        formData.append('academyTownCity', academyTownCity);
        if (academyRegion && academyRegion !== 'undefined') {
            formData.append('academyRegion', academyRegion);
        }
        formData.append('academyPostcode', academyPostcode);
        formData.append('academyContactName', academyContactName);
        formData.append('academyPhoneNumber', academyPhoneNumber);
        formData.append('academyEmail', academyEmail);
        formData.append('academyFax', academyFax);
        if (Array.isArray(representativeIds)) {
            representativeIds.forEach(id => formData.append('representativeIds', id));
        }
        if (avatar) {
            formData.append('avatar', avatar);
        }
        const response = await fetch(`/api/club/add-club`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updateClub = async ({
    id,
    clubDisplayName,
    league,
    addressLine1,
    addressLine2,
    townCity,
    region,
    postcode,
    emailAddress,
    phoneNumber,
    faxNumber,
    trainingGroundName,
    trainingGroundAddressLine1,
    trainingGroundAddressLine2,
    trainingGroundTownCity,
    trainingGroundRegion,
    trainingGroundPostcode,
    trainingGroundEmail,
    trainingGroundTelephone,
    trainingGroundFax,
    academyName,
    academyAddressLine1,
    academyAddressLine2,
    academyTownCity,
    academyRegion,
    academyPostcode,
    academyContactName,
    academyPhoneNumber,
    academyEmail,
    academyFax,
    representativeIds,
    avatar
}) => {
    try {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('clubDisplayName', clubDisplayName);
        if (league) formData.append('league', league);
        formData.append('addressLine1', addressLine1);
        formData.append('addressLine2', addressLine2);
        formData.append('townCity', townCity);
        if (region && region !== 'undefined') {
            formData.append('region', region);
        }
        formData.append('postcode', postcode);
        formData.append('emailAddress', emailAddress);
        formData.append('phoneNumber', phoneNumber);
        formData.append('faxNumber', faxNumber);
        formData.append('trainingGroundName', trainingGroundName);
        formData.append('trainingGroundAddressLine1', trainingGroundAddressLine1);
        formData.append('trainingGroundAddressLine2', trainingGroundAddressLine2);
        formData.append('trainingGroundTownCity', trainingGroundTownCity);
        if (trainingGroundRegion && trainingGroundRegion !== 'undefined') {
            formData.append('trainingGroundRegion', trainingGroundRegion);
        }
        formData.append('trainingGroundPostcode', trainingGroundPostcode);
        formData.append('trainingGroundEmail', trainingGroundEmail);
        formData.append('trainingGroundTelephone', trainingGroundTelephone);
        formData.append('trainingGroundFax', trainingGroundFax);
        formData.append('academyName', academyName);
        formData.append('academyAddressLine1', academyAddressLine1);
        formData.append('academyAddressLine2', academyAddressLine2);
        formData.append('academyTownCity', academyTownCity);
        if (academyRegion && academyRegion !== 'undefined') {
            formData.append('academyRegion', academyRegion);
        }
        formData.append('academyPostcode', academyPostcode);
        formData.append('academyContactName', academyContactName);
        formData.append('academyPhoneNumber', academyPhoneNumber);
        formData.append('academyEmail', academyEmail);
        formData.append('academyFax', academyFax);
        if (Array.isArray(representativeIds)) {
            representativeIds.forEach(id => formData.append('representativeIds', id));
        }
        if (avatar) {
            formData.append('avatar', avatar);
        }
        const response = await fetch(`/api/club/update-club`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updateClubStaff = async (clubId, staffMembers) => {
    try {
        const response = await fetch(`/api/club/update-club-staff`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                clubId,
                staffMembers
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const addClubStaffMember = async (clubId, staffMember) => {
    try {
        const response = await fetch(`/api/club/add-club-staff-member?clubId=${clubId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify(staffMember)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updateClubStaffMember = async (staffMember) => {
    try {
        const response = await fetch(`/api/club/update-club-staff-member`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify(staffMember)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const deleteClubStaffMember = async (clubId, staffId) => {
    try {
        const response = await fetch(`/api/club/delete-club-staff-member?clubId=${clubId}&staffId=${staffId}`, {
            method: "POST",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const setClubRepresentatives = async (clubId, rep1Id, rep2Id) => {
    try {
        const response = await fetch(`/api/club/set-club-representatives`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                id: clubId,
                representative1Id: rep1Id,
                representative2Id: rep2Id
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const setPlayerRepresentatives = async (playerId, rep1Id, rep2Id, rep3Id) => {
    try {
        const response = await fetch(`/api/player/set-player-representatives`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                id: playerId,
                representative1Id: rep1Id,
                representative2Id: rep2Id,
                representative3Id: rep3Id
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const addPlayerContact = async (playerId, contact) => {
    try {
        const response = await fetch(`/api/player/add-player-contact`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({ ...contact, playerId })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updatePlayerContact = async (contact) => {
    try {
        const response = await fetch(`/api/player/update-player-contact`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify(contact)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const deletePlayerContact = async (playerId, contactId) => {
    try {
        const response = await fetch(`/api/player/delete-player-contact?playerId=${playerId}&contactId=${contactId}`, {
            method: "POST",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};
export const addPlayerContract = async ({ playerId, contractType, sharepointLink, startDate, endDate }) => {
    try {
        const response = await fetch(`/api/player/add-player-contract`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                playerId,
                contractType,
                sharepointLink,
                startDate,
                endDate
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, message: "Failed to add contract." };
    }
};

export const deletePlayerContract = async (playerId, contractId) => {
    try {
        const response = await fetch(`/api/player/delete-player-contract?playerId=${playerId}&contractId=${contractId}`, {
            method: "POST",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updatePlayerContract = async ({ playerId, contractId, contractType, sharepointLink, startDate, endDate }) => {
    try {
        const response = await fetch(`/api/player/update-player-contract`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                playerId,
                contractId,
                contractType,
                sharepointLink,
                startDate,
                endDate
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, message: "Failed to update contract." };
    }
};

export const addPlayer = async (player) => {
    try {
        const formData = new FormData();
        if (player.firstName) formData.append('firstName', player.firstName);
        if (player.lastName) formData.append('lastName', player.lastName);
        if (player.dateOfBirth) formData.append('dateOfBirth', player.dateOfBirth);
        if (player.addressLine1) formData.append('addressLine1', player.addressLine1);
        if (player.addressLine2) formData.append('addressLine2', player.addressLine2);
        if (player.townCity) formData.append('townCity', player.townCity);
        if (player.region) {
            if (Array.isArray(player.region)) {
                player.region.forEach(x => formData.append('region', x));
            } else {
                formData.append('region', player.region);
            }
        }
        if (player.postcode) formData.append('postcode', player.postcode);
        if (player.emailAddress) formData.append('emailAddress', player.emailAddress);
        if (player.phoneNumber) formData.append('phoneNumber', player.phoneNumber);
        if (player.mobileNumber) formData.append('mobileNumber', player.mobileNumber);
        if (player.website) formData.append('website', player.website);
        if (player.twitter) formData.append('twitter', player.twitter);
        if (player.facebook) formData.append('facebook', player.facebook);
        if (player.instagram) formData.append('instagram', player.instagram);
        if (player.youTube) formData.append('youTube', player.youTube);
        if (player.height) formData.append('height', player.height);
        if (player.weight) formData.append('weight', player.weight);
        if (Array.isArray(player.nationality)) player.nationality.forEach(x => formData.append('nationality', x));
        if (Array.isArray(player.status)) player.status.forEach(x => formData.append('status', x));
        if (Array.isArray(player.position)) player.position.forEach(x => formData.append('position', x));
        if (player.primaryClub) formData.append('primaryClub', player.primaryClub);
        if (player.loanClub) formData.append('loanClub', player.loanClub);
        if (Array.isArray(player.internationalClub)) player.internationalClub.forEach(x => formData.append('internationalClub', x));
        if (Array.isArray(player.footedness)) player.footedness.forEach(x => formData.append('footedness', x));
        if (player.outOfContract) formData.append('outOfContract', player.outOfContract);
        if (Array.isArray(player.outOfContractCountry)) player.outOfContractCountry.forEach(x => formData.append('outOfContractCountry', x));
        if (Array.isArray(player.outOfContractLeague)) player.outOfContractLeague.forEach(x => formData.append('outOfContractLeague', x));
        if (player.availableForLoan) formData.append('availableForLoan', player.availableForLoan);
        if (Array.isArray(player.availableForLoanCountry)) player.availableForLoanCountry.forEach(x => formData.append('availableForLoanCountry', x));
        if (Array.isArray(player.availableForLoanLeague)) player.availableForLoanLeague.forEach(x => formData.append('availableForLoanLeague', x));
        if (player.offerSheet) formData.append('offerSheet', player.offerSheet);
        if (player.offerSheetPerformanceLevel) formData.append('offerSheetPerformanceLevel', player.offerSheetPerformanceLevel);
        if (Array.isArray(player.offerSheetLoanTransfer)) player.offerSheetLoanTransfer.forEach(x => formData.append('offerSheetLoanTransfer', x));
        if (player.faLog) formData.append('faLog', player.faLog);
        if (Array.isArray(player.representativeIds)) player.representativeIds.forEach(x => formData.append('representativeIds', x));
        if (player.avatar) formData.append('avatar', player.avatar);

        const response = await fetch(`/api/player/add-player`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const updatePlayer = async (player) => {
    try {
        const formData = new FormData();
        formData.append('id', player.id);
        if (player.firstName) formData.append('firstName', player.firstName);
        if (player.lastName) formData.append('lastName', player.lastName);
        if (player.dateOfBirth) formData.append('dateOfBirth', player.dateOfBirth);
        if (player.addressLine1) formData.append('addressLine1', player.addressLine1);
        if (player.addressLine2) formData.append('addressLine2', player.addressLine2);
        if (player.townCity) formData.append('townCity', player.townCity);
        if (Array.isArray(player.region)) player.region.forEach(x => formData.append('region', x));
        if (player.postcode) formData.append('postcode', player.postcode);
        if (player.emailAddress) formData.append('emailAddress', player.emailAddress);
        if (player.phoneNumber) formData.append('phoneNumber', player.phoneNumber);
        if (player.mobileNumber) formData.append('mobileNumber', player.mobileNumber);
        if (player.website) formData.append('website', player.website);
        if (player.twitter) formData.append('twitter', player.twitter);
        if (player.facebook) formData.append('facebook', player.facebook);
        if (player.instagram) formData.append('instagram', player.instagram);
        if (player.youTube) formData.append('youTube', player.youTube);
        if (player.height) formData.append('height', player.height);
        if (player.internationalStatus) formData.append('internationalStatus', player.internationalStatus);
        if (player.weight) formData.append('weight', player.weight);
        if (Array.isArray(player.nationality)) player.nationality.forEach(x => formData.append('nationality', x));
        if (Array.isArray(player.status)) player.status.forEach(x => formData.append('status', x));
        if (Array.isArray(player.position)) player.position.forEach(x => formData.append('position', x));
        if (player.primaryClub) formData.append('primaryClub', player.primaryClub);
        if (player.loanClub) formData.append('loanClub', player.loanClub);
        if (Array.isArray(player.internationalClub)) player.internationalClub.forEach(x => formData.append('internationalClub', x));
        if (Array.isArray(player.footedness)) player.footedness.forEach(x => formData.append('footedness', x));
        if (player.outOfContract) formData.append('outOfContract', player.outOfContract);
        if (Array.isArray(player.outOfContractCountry)) player.outOfContractCountry.forEach(x => formData.append('outOfContractCountry', x));
        if (Array.isArray(player.outOfContractLeague)) player.outOfContractLeague.forEach(x => formData.append('outOfContractLeague', x));
        if (player.availableForLoan) formData.append('availableForLoan', player.availableForLoan);
        if (Array.isArray(player.availableForLoanCountry)) player.availableForLoanCountry.forEach(x => formData.append('availableForLoanCountry', x));
        if (Array.isArray(player.availableForLoanLeague)) player.availableForLoanLeague.forEach(x => formData.append('availableForLoanLeague', x));
        if (player.offerSheet) formData.append('offerSheet', player.offerSheet);
        if (player.offerSheetPerformanceLevel) formData.append('offerSheetPerformanceLevel', player.offerSheetPerformanceLevel);
        if (Array.isArray(player.offerSheetLoanTransfer)) player.offerSheetLoanTransfer.forEach(x => formData.append('offerSheetLoanTransfer', x));
        if (player.faLog) formData.append('faLog', player.faLog);
        if (Array.isArray(player.representativeIds)) player.representativeIds.forEach(x => formData.append('representativeIds', x));
        if (player.avatar) formData.append('avatar', player.avatar);

        const response = await fetch(`/api/player/update-player`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

// Get automatched candidates for a club requirement
export const getAutomatchCandidates = async (clubRequirementId) => {
    try {
        const response = await fetch(`/api/clubrequirement/get-automatch-candidates?clubRequirementId=${clubRequirementId}`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

// Ignore an automatched candidate
export const ignoreAutomatchCandidate = async (requirementId, playerId) => {
    try {
        const response = await fetch(`/api/clubrequirement/ignore-automatch-candidate`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                requirementId,
                playerId
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

// Get ignored automatched candidates for a club requirement
export const getIgnoredAutomatchCandidates = async (clubRequirementId) => {
    try {
        const response = await fetch(`/api/clubrequirement/get-ignored-automatch-candidates?clubRequirementId=${clubRequirementId}`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

// Reinstate an ignored automatched candidate
export const reinstateAutomatchCandidate = async (requirementId, playerId) => {
    try {
        const response = await fetch(`/api/clubrequirement/reinstate-automatch-candidate`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                requirementId,
                playerId
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

// Update candidate skills and budget
export const updateCandidate = async (candidateId, skills, budget, status) => {
    try {
        const response = await fetch(`/api/clubrequirement/update-candidate`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
                candidateId,
                skills,
                budget,
                status
            })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const searchPlayersPaginated = async ({
    searchTerm = "",
    page = 1,
    pageSize = 50,
    sortField = "FirstName",
    sortOrder = 1,
    filters = {}
}) => {
    const payload = {
        searchTerm,
        pageNumber: page,
        pageSize,
        sortField,
        sortOrder,
        status: filters.status || [],
        club: filters.club || [],
        representative: filters.representative || [],
        position: filters.position || [],
        player: filters.player || [],
        transferSheets: filters.transferSheets || [],
        country: filters.country || [],
    };

    try {
        const response = await fetch("/api/search/player-search", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Server returned status ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        console.error("Error fetching player data:", error);
        return {
            items: [],
            totalCount: 0,
            pageNumber: page,
            pageSize,
            responseStatus: 500
        };
    }
};

export const searchPlayersFilters = async ({
    searchTerm = "",
    filters = {}
}) => {
    const params = new URLSearchParams();
    
    if (searchTerm) params.append('searchTerm', searchTerm);
    if (filters.status?.length) filters.status.forEach(s => params.append('status', s));
    if (filters.club?.length) filters.club.forEach(c => params.append('club', c));
    if (filters.representative?.length) filters.representative.forEach(r => params.append('representative', r));
    if (filters.position?.length) filters.position.forEach(p => params.append('position', p));
    if (filters.player?.length) filters.player.forEach(p => params.append('player', p));
    if (filters.transferSheets?.length) filters.transferSheets.forEach(t => params.append('transferSheets', t));
    if (filters.country?.length) filters.country.forEach(c => params.append('country', c));

    try {
        const response = await fetch(`/api/search/player-search-filters?${params.toString()}`, {
            method: "GET",
            credentials: "include"
        });

        if (!response.ok) {
            throw new Error(`Server returned status ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        console.error("Error fetching player filters:", error);
        return {
            responseStatus: 500
        };
    }
};

export const bulkUpdatePlayerStatus = async (playerIds, status) => {
    try {
        const response = await fetch("/api/player/bulk-update-status", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ playerIds, status })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.message || `Server returned status ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error bulk updating player status:", error);
        throw error;
    }
};

// Club search paginated
export const searchClubsPaginated = async ({
    searchTerm = "",
    page = 1,
    pageSize = 50,
    sortField = "ClubDisplayName",
    sortOrder = 1,
    filters = {}
}) => {
    const payload = {
        searchTerm,
        pageNumber: page,
        pageSize,
        sortField,
        sortOrder,
        club: filters.club || [],
        league: filters.league && Array.isArray(filters.league) && filters.league.length > 0 ? filters.league.join(",") : "",
        region: filters.country && Array.isArray(filters.country) && filters.country.length > 0 ? filters.country.join(",") : ""
    };

    try {
        const response = await fetch("/api/search/club-search", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber: page, pageSize, responseStatus: 401 };
    }
};
// Club search paginated
export const searchClubsFilters = async ({
    searchTerm = "",
    filters = {}
}) => {
    const params = new URLSearchParams();
    
    if (searchTerm) params.append('searchTerm', searchTerm);
    if (filters.league) params.append('league', filters.league);
    if (filters.country) params.append('region', filters.country);
    if (filters.club?.length) filters.club.forEach(c => params.append('club', c));

    try {
        const response = await fetch(`/api/search/club-search-filters?${params.toString()}`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { responseStatus: 401 };
    }
};

export const getPermissionsSet = async (permissionPageGuid, playerId = 0) => {
    try {
        const response = await fetch(`/api/permissions/get-permissions-set?page=${permissionPageGuid}&playerId=${playerId}`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const getAnalysisPlayers = async ({
    searchTerm = "",
    pageNumber = 1,
    pageSize = 9999999999,
    leagues = [],
    statuses = [],
    positions = [],
    feet = [],
    reps = [],
    offices = [],
    dobFrom = null,
    dobTo = null,
    repContractEndFrom = null,
    repContractEndTo = null,
    availableForLoan = null,
    repOfficeText = null,
    playerAge = null,
    nationality = [],
    outOfContract = null,
    repContractStartFrom = null,
    repContractStartTo = null,
    offerSheet = null,
    clubName = [],
    loanClubName = [],
    clubContractStartFrom = null,
    clubContractStartTo = null,
    clubContractEndFrom = null,
    clubContractEndTo = null,
    dobMonth = null,
    faLog = null,
    playerAgeFrom = null,
    playerAgeTo = null,
    sortField = "FirstName",
    sortOrder = 1
} = {}) => {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    params.append("pageNumber", pageNumber);
    params.append("pageSize", pageSize);
    leagues.forEach(l => params.append("leagues", l));
    statuses.forEach(s => params.append("statuses", s));
    positions.forEach(p => params.append("positions", p));
    feet.forEach(f => params.append("feet", f));
    reps?.forEach(r => params.append("reps", r));
    offices.forEach(o => params.append("offices", o));
    
    clubName?.forEach(o => params.append("clubName", o));
    loanClubName?.forEach(o => params.append("loanClubName", o));
    if (dobFrom) params.append("dobFrom", dobFrom);
    if (dobTo) params.append("dobTo", dobTo);
    if (repContractEndFrom) params.append("repContractEndFrom", repContractEndFrom);
    if (repContractEndTo) params.append("repContractEndTo", repContractEndTo);
    if (availableForLoan !== null) params.append("availableForLoan", availableForLoan);
    if (repOfficeText) params.append("repOfficeText", repOfficeText);
    if (playerAge) params.append("playerAge", playerAge);
    nationality.forEach(n => params.append("nationality", n));
    if (outOfContract !== null) params.append("outOfContract", outOfContract);
    if (repContractStartFrom) params.append("repContractStartFrom", repContractStartFrom);
    if (repContractStartTo) params.append("repContractStartTo", repContractStartTo);
    if (offerSheet !== null) params.append("offerSheet", offerSheet);
    if (faLog !== null) params.append("faLog", faLog);
    if (clubContractStartFrom) params.append("clubContractStartFrom", clubContractStartFrom);
    if (clubContractStartTo) params.append("clubContractStartTo", clubContractStartTo);
    if (clubContractEndFrom) params.append("clubContractEndFrom", clubContractEndFrom);
    if (clubContractEndTo) params.append("clubContractEndTo", clubContractEndTo);
    if (dobMonth) params.append("dobMonth", dobMonth);
    if (playerAgeFrom !== null && playerAgeFrom !== undefined) params.append("playerAgeFrom", playerAgeFrom);
    if (playerAgeTo !== null && playerAgeTo !== undefined) params.append("playerAgeTo", playerAgeTo);
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    try {
        const response = await fetch(`/api/player/analysis?${params.toString()}`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber, pageSize, responseStatus: 401 };
    }
};


export const doAnalysisPlayersExport = async ({
    searchTerm = "",
    pageNumber = 1,
    pageSize = 9999999999,
    leagues = [],
    statuses = [],
    positions = [],
    feet = [],
    reps = [],
    offices = [],
    dobFrom = null,
    dobTo = null,
    repContractEndFrom = null,
    repContractEndTo = null,
    availableForLoan = null,
    repOfficeText = null,
    playerAge = null,
    nationality = [],
    outOfContract = null,
    repContractStartFrom = null,
    repContractStartTo = null,
    offerSheet = null,
    clubName = [],
    loanClubName = [],
    clubContractStartFrom = null,
    clubContractStartTo = null,
    clubContractEndFrom = null,
    clubContractEndTo = null,
    dobMonth = null,
    faLog = null,
    playerAgeFrom = null,
    playerAgeTo = null,
    sortField = "FirstName",
    sortOrder = 1
} = {}) => {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    params.append("pageNumber", pageNumber);
    params.append("pageSize", pageSize);
    leagues.forEach(l => params.append("leagues", l));
    statuses.forEach(s => params.append("statuses", s));
    positions.forEach(p => params.append("positions", p));
    feet.forEach(f => params.append("feet", f));
    reps?.forEach(r => params.append("reps", r));
    clubName?.forEach(o => params.append("clubName", o));
    loanClubName?.forEach(o => params.append("loanClubName", o));
    offices.forEach(o => params.append("offices", o));
    if (dobFrom) params.append("dobFrom", dobFrom);
    if (dobTo) params.append("dobTo", dobTo);
    if (repContractEndFrom) params.append("repContractEndFrom", repContractEndFrom);
    if (repContractEndTo) params.append("repContractEndTo", repContractEndTo);
    if (availableForLoan !== null) params.append("availableForLoan", availableForLoan);
    if (repOfficeText) params.append("repOfficeText", repOfficeText);
    if (playerAge) params.append("playerAge", playerAge);
    nationality.forEach(n => params.append("nationality", n));
    if (outOfContract !== null) params.append("outOfContract", outOfContract);
    if (repContractStartFrom) params.append("repContractStartFrom", repContractStartFrom);
    if (repContractStartTo) params.append("repContractStartTo", repContractStartTo);
    if (offerSheet !== null) params.append("offerSheet", offerSheet);
    if (faLog !== null) params.append("faLog", faLog);
    if (clubContractStartFrom) params.append("clubContractStartFrom", clubContractStartFrom);
    if (clubContractStartTo) params.append("clubContractStartTo", clubContractStartTo);
    if (clubContractEndFrom) params.append("clubContractEndFrom", clubContractEndFrom);
    if (clubContractEndTo) params.append("clubContractEndTo", clubContractEndTo);
    if (dobMonth) params.append("dobMonth", dobMonth);
    if (playerAgeFrom !== null && playerAgeFrom !== undefined) params.append("playerAgeFrom", playerAgeFrom);
    if (playerAgeTo !== null && playerAgeTo !== undefined) params.append("playerAgeTo", playerAgeTo);
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);
    
    try {
        const response = await fetch(`/api/player/analysis-export?${params.toString()}`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.blob();
        const url = window.URL.createObjectURL(json);
        window.location.href = url;
        return { success: true, url };
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber, pageSize, responseStatus: 401 };
    }
};

export const getTemplates = async () => {
    try {
        const response = await fetch(`/api/taxonomy/get-templates`, {
            method: "GET",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return [];
    }
};

export const saveTemplate = async (name, schema) => {
    try {
        const response = await fetch(`/api/taxonomy/save-template`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({ name, schema })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false };
    }
};

export const deleteTemplate = async (id) => {
    try {
        const response = await fetch(`/api/taxonomy/delete-template?id=${id}`, {
            method: "POST",
            credentials: "include"
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false };
    }
};

export const searchMatchReportsPaginated = async ({
    searchTerm = "",
    page = 1,
    pageSize = 20,
    sortField = "MatchDate",
    sortOrder = -1,
    filters = {}
}) => {
    const payload = {
        searchTerm,
        pageNumber: page,
        pageSize,
        sortField,
        sortOrder,
        homeTeam: filters.homeTeam || [],
        awayTeam: filters.awayTeam || [],
        reporter: filters.reporter || [],
        ageGroup: filters.ageGroup || []
    };

    try {
        const response = await fetch("/api/matchreport/search-match-reports", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Server returned status ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        return {
            items: [],
            totalCount: 0,
            pageNumber: page,
            pageSize,
            responseStatus: 500
        };
    }
};
export const searchMatchReportsFilters = async ({
    searchTerm = "",
    page = 1,
    pageSize = 20,
    sortField = "MatchDate",
    sortOrder = -1,
    filters = {}
}) => {
    const payload = {
        searchTerm,
        pageNumber: page,
        pageSize,
        sortField,
        sortOrder,
        homeTeam: filters.homeTeam || [],
        awayTeam: filters.awayTeam || [],
        reporter: filters.reporter || [],
        ageGroup: filters.ageGroup || []
    };

    try {
        const response = await fetch("/api/matchreport/search-match-reports-filters", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Server returned status ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        return {
            items: [],
            totalCount: 0,
            pageNumber: page,
            pageSize,
            responseStatus: 500
        };
    }
};

export const searchMatchReportsForPlayerPaginated = async (playerId, {
    searchTerm = "",
    page = 1,
    pageSize = 20,
    sortField = "MatchDate",
    sortOrder = -1,
    filters = {}
}) => {
    const payload = {
        searchTerm,
        pageNumber: page,
        pageSize,
        sortField,
        sortOrder,
        homeTeam: filters.homeTeam || [],
        awayTeam: filters.awayTeam || [],
        reporter: filters.reporter || [],
        ageGroup: filters.ageGroup || []
    };

    try {
        const response = await fetch(`/api/matchreport/search-match-reports-for-player/${playerId}`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Server returned status ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        return {
            items: [],
            totalCount: 0,
            pageNumber: page,
            pageSize,
            responseStatus: 500
        };
    }
};

export const searchMatchReportsForPlayerFilters = async (playerId, {
    searchTerm = "",
    page = 1,
    pageSize = 20,
    sortField = "MatchDate",
    sortOrder = -1,
    filters = {}
}) => {
    const payload = {
        searchTerm,
        pageNumber: page,
        pageSize,
        sortField,
        sortOrder,
        homeTeam: filters.homeTeam || [],
        awayTeam: filters.awayTeam || [],
        reporter: filters.reporter || [],
        ageGroup: filters.ageGroup || []
    };

    try {
        const response = await fetch(`/api/matchreport/search-match-reports-for-player-filters/${playerId}`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Server returned status ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        return {
            items: [],
            totalCount: 0,
            pageNumber: page,
            pageSize,
            responseStatus: 500
        };
    }
};

// ---------------------------------------------------------------------------
// League Manager
// ---------------------------------------------------------------------------

export const getLeagues = async ({ pageNumber = 1, pageSize = 10, sortField = "name", sortOrder = 1, search = "" } = {}) => {
    try {
        const params = new URLSearchParams({ pageNumber, pageSize, sortField, sortOrder });
        if (search) params.append("search", search);
        const response = await fetch(`/api/league/get-leagues?${params.toString()}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber, pageSize, responseStatus: 401 };
    }
};

export const getLeagueClubs = async (identifier, { pageNumber = 1, pageSize = 10, sortField = "clubdisplayname", sortOrder = 1, search = "" } = {}) => {
    try {
        const params = new URLSearchParams({ identifier, pageNumber, pageSize, sortField, sortOrder });
        if (search) params.append("search", search);
        const response = await fetch(`/api/league/get-league-clubs?${params.toString()}`, {
            method: "GET",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { items: [], totalCount: 0, pageNumber, pageSize, responseStatus: 401 };
    }
};

export const addLeague = async (name) => {
    try {
        const response = await fetch(`/api/league/add-league`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const renameLeague = async (identifier, name) => {
    try {
        const response = await fetch(`/api/league/rename-league`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ identifier, name })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const deleteLeague = async (identifier) => {
    try {
        const response = await fetch(`/api/league/delete-league?identifier=${encodeURIComponent(identifier)}`, {
            method: "DELETE",
            credentials: "include",
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const getClubsCurrentLeagues = async (clubIds) => {
    try {
        const response = await fetch(`/api/league/get-clubs-current-leagues`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(clubIds)
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return [];
    }
};

export const addClubsToLeague = async (identifier, clubIds) => {
    try {
        const response = await fetch(`/api/league/add-clubs-to-league`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ identifier, clubIds })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};

export const removeClubFromLeague = async (identifier, clubId) => {
    try {
        const response = await fetch(`/api/league/remove-club-from-league`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ identifier, clubId })
        });
        const json = await response.json();
        return json;
    } catch (error) {
        return { success: false, responseStatus: 401 };
    }
};